import React, { useState, useEffect } from 'react';
import { Table, Button, message, Space, Tag } from 'antd';
import { get } from '../../utils/http';

interface Task {
  id: string;
  scene_id: string;
  status: string;
  created_time: string;
  start_time: string | null;
  end_time: string | null;
  error: string | null;
  result: {
    word_count: number;
    phrase_count: number;
  } | null;
}

function TaskList() {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchTasks = async () => {
    setLoading(true);
    try {
      const response = await get('/api/manage/tasks');
      if (response?.data?.code === 0) {
        setTasks(response.data.data.tasks || []);
      } else {
        message.error('获取任务列表失败');
      }
    } catch (error) {
      console.error('获取任务列表失败:', error);
      message.error('获取任务列表失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
  }, []);

  const columns = [
    {
      title: '任务ID',
      dataIndex: 'id',
      key: 'id',
      render: (text: string) => <span>{text.slice(0, 8)}...</span>,
    },
    {
      title: '场景ID',
      dataIndex: 'scene_id',
      key: 'scene_id',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => {
        let color = '';
        let text = '';
        switch (status) {
          case 'pending':
            color = 'blue';
            text = '待处理';
            break;
          case 'running':
            color = 'orange';
            text = '运行中';
            break;
          case 'success':
            color = 'green';
            text = '成功';
            break;
          case 'failed':
            color = 'red';
            text = '失败';
            break;
          default:
            color = 'default';
            text = status;
        }
        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: '创建时间',
      dataIndex: 'created_time',
      key: 'created_time',
      render: (time: string) => new Date(time).toLocaleString(),
    },
    {
      title: '开始时间',
      dataIndex: 'start_time',
      key: 'start_time',
      render: (time: string | null) => time ? new Date(time).toLocaleString() : '-',
    },
    {
      title: '结束时间',
      dataIndex: 'end_time',
      key: 'end_time',
      render: (time: string | null) => time ? new Date(time).toLocaleString() : '-',
    },
    {
      title: '结果',
      dataIndex: 'result',
      key: 'result',
      render: (result: any) => {
        if (!result) return '-';
        return (
          <div>
            <p>单词: {result.word_count}</p>
            <p>短语: {result.phrase_count}</p>
          </div>
        );
      },
    },
    {
      title: '错误信息',
      dataIndex: 'error',
      key: 'error',
      render: (error: string | null) => error || '-',
    },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: Task) => (
        <Space size="middle">
          <Button type="link" onClick={() => fetchTasks()}>刷新</Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1>任务管理</h1>
        <Button type="primary" onClick={fetchTasks} loading={loading}>
          刷新任务列表
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={tasks}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 10 }}
      />
    </div>
  );
}

export default TaskList;